import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { initTracking } from "./utils/analytics";

// Pixel de Meta + GTM al <head> antes de montar la app, para registrar PageView lo antes posible
initTracking();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-366" data-mp="2677nxaeo8cs5" />);
}